import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { BellIcon, BellSlashIcon } from '@heroicons/react/24/outline';
import { usePushNotifications } from '@/hooks/usePushNotifications';
import { toast } from '@/components/ui/Toast';
export function NotificationToggle() {
    const { t } = useTranslation();
    const { supported, permission, subscribed, subscribe, unsubscribe } = usePushNotifications();
    if (!supported)
        return null;
    const onClick = async () => {
        try {
            if (subscribed) {
                await unsubscribe();
                toast.info(t('notifications.notSupported'));
            }
            else {
                await subscribe();
                toast.success(t('notifications.enabled'));
            }
        }
        catch (e) {
            toast.error(e?.message || (permission === 'denied' ? t('notifications.denied') : 'خطا'));
        }
    };
    return (_jsx("button", { onClick: onClick, title: subscribed ? t('notifications.enabled') : t('notifications.enable'), "aria-label": subscribed ? t('notifications.enabled') : t('notifications.enable'), className: `rounded-full border border-gray-200 bg-white p-1.5 text-gray-500 hover:text-gray-700 dark:border-gray-700 dark:bg-gray-900 dark:hover:text-gray-300 ${subscribed ? 'text-arshe-600 dark:text-arshe-400' : ''}`, children: subscribed ? _jsx(BellIcon, { className: "h-4 w-4" }) : _jsx(BellSlashIcon, { className: "h-4 w-4" }) }));
}
